export interface SetSnackbarMessageAction {
  type: 'SET_SNACKBAR_MESSAGE'
  value: string
}

export interface ClearSnackbarAction {
  type: 'CLEAR_SNACKBAR'
}

export type SnackbarAction = SetSnackbarMessageAction | ClearSnackbarAction

export const setSnackbarMessage = (value: string): SetSnackbarMessageAction => ({
  type: 'SET_SNACKBAR_MESSAGE',
  value
})

export const clearSnackbar = (): ClearSnackbarAction => ({
  type: 'CLEAR_SNACKBAR'
})
